import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import "@maersk-global/mds-components-core/mc-radio";
import '@maersk-global/mds-components-core/mc-radio-group';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { UserConfigService } from '../../../src/services/user-config-services';
import { AuthService } from '../../../src/services/auth-service';

@customElement('voyage-map-view-options')
export class VoyageMapViewOptions extends LitElement {
    @property({type: Boolean}) shown: boolean = false;
    @property() mapViewNames = [ 
        {
            label:"World Map",
            value:"simplified",
            checked: true
        },
        {
            label:"Sea chart - Basic",
            value:"basic",
            checked: false
        },
        {
            label:"Sea chart - Standard",
            value:"standard",
            checked: false
        },
        {
            label:"Sea chart - Advanced",
            value:"advanced",
            checked: false
        }]
    
    constructor() {
        super();
        this.onSelectedMapViewChange = this.onSelectedMapViewChange.bind(this);
    }
    
    static get styles() {
        return [
            css`
            :host {
                display: none;
            }

            :host([shown]) {
                display: flex;
            }

            .container {
                font-family: 'MaerskText';
                font-size: 14px;
                background: var(--neutrals-grey-10);
                border: 1px solid var(--neutrals-grey-7);
                border-radius: 3px;
                display: grid;
                grid-gap: 12px;
                grid-template-rows: auto, auto;
                width: 100%;
                padding-bottom: 24px;
            }
        `];
    }

    render() {
        return html`
            <div class="container">
                    ${this.mapViewNames.map(name => this.renderRadio(name))}
            </div>
        `;
    }

    connectedCallback(): void {
        super.connectedCallback();
        UiStateModel!.addEventListener(`${UiStateModelParam.SelecteMapView}-change`, this.onSelectedMapViewChange);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        UiStateModel!.addEventListener(`${UiStateModelParam.SelecteMapView}-change`, this.onSelectedMapViewChange);
    }

    onSelectedMapViewChange(){
        let selectedOption = UiStateModel!.getValue(UiStateModelParam.SelecteMapView) || null;
        if(selectedOption){
            this.updateSelection(selectedOption)
        }
    }

    firstUpdated() {
        this.onSelectedMapViewChange();
    }

    updateSelection(selectedOption?: string){
        this.mapViewNames.forEach(option => {
            option.checked = (option.value === selectedOption);
        });
    }
    
    renderRadio(option: any) {
        return html`
        <mc-radio 
            name="${option.label}" 
            value="${option.value}" 
            label="${option.label}"
            id="${option.value}"
            class="map-view-option" 
            ?checked=${option.checked}  
            @change=${(evt:InputEvent) => this.dispatchSelectionChangeEvent(option.value)}>
        </mc-radio>
        `
    }

    dispatchSelectionChangeEvent(value: string) {
        this.updateSelection(value);
        this.dispatchEvent(new CustomEvent('map-view-option-changed', { detail: { selectedOption: value } }));
        this.requestUpdate();
        UiStateModel!.setValue(UiStateModelParam.SelecteMapView, value);
        UserConfigService.upsertUserMapView({"type": "map", "user_id": AuthService.getCurrentUserId(), "data": {value: value}});
    }
};
